import React from 'react';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { getAboundToken } from './AboundUtils';

const REINIT_ABOUND_WIDGET_EVENT_NAME = 'reinit_abound_widget';

export function reinitializeAboundWidgets(obj) {
  const initEvent = new Event(REINIT_ABOUND_WIDGET_EVENT_NAME);
  if (typeof obj === 'object' && obj.divId && obj.widgetType) {
    initEvent.customObj = obj;
  }
  window.dispatchEvent(initEvent);
}

class AboundSDK extends React.Component {
  constructor(props) {
    super(props);
    this.AboundConfig = {
      widgettypes: [
        {
          widgetType: 'aboudwidget-profile',
          platform: 'web',
          channel: 'TOI',
          ele: 'aboundProfile',
          viewportId: 'TOI',
          ticketIdRequired: true,
        },
        // { divId: 'widget-head', widgetType: 'abound-widget-one' },
        // { divId: 'widget-sticky', widgetType: 'abound-widget-two' },
        // { divId: 'widget-two-ATF', widgetType: 'abound-widget-two' },
        // { divId: 'widget-two-BTF', widgetType: 'abound-widget-two' },
        // { divId: 'widget-two', widgetType: 'abound-widget-two' },
        // { divId: 'widget-two-vs', widgetType: 'abound-widget-two' },
        // {
        //   divId: 'widget-banner',
        //   widgetType: 'abound-widget-banner',
        //   viewportId: 'TOI',
        //   carousel: true,
        //   platform: this.props.isWapView ? 'msite' : 'web',
        // },
        // {
        //   divId: 'abound-widget-offer-full',
        //   widgetType: 'abound-widget-offer-full',
        //   platform: this.props.isWapView ? 'msite' : 'web',
        // },
      ],
    };
  }

  componentDidMount() {
    this.loadSDK();
  }

  // eslint-disable-next-line class-methods-use-this
  loadSDK() {
    window.abound_js = (function loadJS(d, sc, cb) {
      const script = document.createElement(sc);
      script.src = __PROD__
        ? 'https://loyalty.joinabound.com/widget/static/dist/js/main.js'
        : 'https://aboundcash-tp-dev.s3.us-east-2.amazonaws.com/static/aboundcash-widget-dev/static/dist/js/main.js';
      script.type = 'text/javascript';
      script.async = true;
      script.onload = cb;
      const node = d.getElementsByTagName('script')[0];
      node.parentNode.insertBefore(script, node);
    })(document, 'script', () => {
      // document.body.addEventListener('aboundcash-widget-ready', () => {
      // this.initialiseTimesPoint();
      // console.log('Abound SDK is loaded');
      // });
    });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps?.userAboundData?.clientToken !==
      this.props?.userAboundData?.clientToken
    ) {
      try {
        this.initialiseTimesPoint();
      } catch (error) {
        console.log('Reinitilization Failed:', error);
      }
    }
  }

  initialiseTimesPoint(obj) {
    this.a = '';
    const widgettypes = (typeof obj === 'object'
      ? [obj]
      : this.AboundConfig.widgettypes
    ).map(
      item =>
        item.divId === 'widget-banner'
          ? {
              ele: item.divId,
              widgetType: item.widgetType,
              viewportId: item.viewportId,
              platform: item.platform,
              carousel: item.carousel,
              channel: 'TOI',
              ticketIdRequired: true,
            }
          : {
              ele: item.divId,
              widgetType: item.widgetType,
              channel: 'TOI',
              platform: this.props.isWapView ? 'msite' : 'web',
              ticketIdRequired: true,
            },
    );
    const widgettypesTicketIdRequired = {};
    widgettypesTicketIdRequired.widgets = widgettypes.filter(
      item => item.ticketIdRequired,
    );
    widgettypesTicketIdRequired.ticketIdRequired = true;
    widgettypes.widgets = widgettypes.filter(item => !item.ticketIdRequired);
    if (
      typeof window.AboundCashWidget !== 'undefined' &&
      typeof window.AboundCashWidget.init === 'function'
    ) {
      [widgettypesTicketIdRequired, widgettypes].map(item => {
        if (
          !item.ticketIdRequired &&
          item?.widgets &&
          Array.isArray(item.widgets) &&
          item.widgets.length > 0
        ) {
          if (getAboundToken()) {
            this.ticketId = getAboundToken();
            window.AboundCashWidget.init({
              widgets: item.widgets,
              userLoginInfo: {
                ticketId: this.ticketId,
              },
            });
          } else {
            window.AboundCashWidget.init({
              widgets: item.widgets,
            });
          }
        } else if (
          item.ticketIdRequired &&
          getAboundToken() &&
          item?.widgets &&
          Array.isArray(item.widgets) &&
          item.widgets.length > 0
        ) {
          this.ticketId = getAboundToken();
          analyticsWrapper('ga4', {
            event: 'user_shown',
            type: 'profile_screen_call_up',
            category: 'abound',
          });
          window.AboundCashWidget.init({
            widgets: item.widgets,
            userLoginInfo: {
              ticketId: this.ticketId,
            },
          });
        }
        return true;
      });
    }
  }
  render() {
    return null;
  }
}

export default AboundSDK;
